























import { defineComponent, PropType } from "@vue/composition-api";
import { Image } from "vant";

interface Data {
  title: string;
  total: {
    value: number;
    unitPrefix: string;
  };
  list: [
    {
      value: number;
      unit: string;
      label: string;
      image?: string;
    }
  ];
}

export default defineComponent({
  name: "share",
  components: {
    [Image.name]: Image
  },
  props: {
    data: {
      type: Object as PropType<Data>
    }
  }
});
